import React from "react";

export const SearchLupeIcon = () => {
  return (
    <svg
      width="10"
      height="10"
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.78295 3.92697C6.78295 4.04799 6.77295 4.16687 6.75831 4.28397H3.21297C3.01555 4.28397 2.85598 4.12403 2.85598 3.92697C2.85598 3.72991 3.01555 3.56997 3.21297 3.56997H6.75831C6.77295 3.68707 6.78295 3.80595 6.78295 3.92697ZM3.21297 2.85598H6.57267C6.46736 2.5968 6.32563 2.35689 6.15285 2.14198H3.21297C3.01555 2.14198 2.85598 2.30192 2.85598 2.49898C2.85598 2.69604 3.01555 2.85598 3.21297 2.85598ZM2.85598 5.35496C2.85598 5.55202 3.01555 5.71195 3.21297 5.71195H6.15285C6.32563 5.49704 6.46736 5.25714 6.57267 4.99796H3.21297C3.01555 4.99796 2.85598 5.15789 2.85598 5.35496ZM9.78672 9.78672C9.49684 10.0766 9.05595 10.0655 8.77713 9.78672L7.34914 8.35873C7.16279 8.17238 7.10389 7.90927 7.16672 7.67151L6.43951 6.94431C5.75836 7.51193 4.88265 7.85394 3.92697 7.85394C1.75821 7.85394 0 6.09573 0 3.92697C0 1.75821 1.75821 0 3.92697 0C6.09573 0 7.85394 1.75821 7.85394 3.92697C7.85394 4.88265 7.51193 5.75836 6.94395 6.43916L7.67115 7.16636C7.90891 7.10353 8.17202 7.16243 8.35837 7.34878L9.78636 8.77677C10.0655 9.05595 10.0655 9.5079 9.78672 9.78672ZM7.13994 3.92697C7.13994 2.15234 5.7016 0.713994 3.92697 0.713994C2.15234 0.713994 0.713994 2.15234 0.713994 3.92697C0.713994 5.7016 2.15234 7.13994 3.92697 7.13994C5.7016 7.13994 7.13994 5.7016 7.13994 3.92697Z"
        fill="#7B59F8"
      />
    </svg>
  );
};

